class CollectionCustomFilter extends HTMLElement {
    constructor() {
        super();
        this.itemDoms = this.querySelectorAll('.custom-filter-link-item a');

        this.itemDoms.forEach(itemDom => {
            itemDom.addEventListener('click', this.onClick.bind(this));
        });
    }

    onClick(event) {
        event.preventDefault();
        const linkDom = event.currentTarget;
        if (!linkDom) {
            return;
        }
        const link = linkDom.getAttribute('href');
        if (!link || link === '#') {
            return;
        }
        let linkToFetch = new URL(link, window.location.origin);
        // find filter.p.m.custom.available_regions in link
        const availableRegionsFilter = window.location.search.includes('filter.p.m.custom.available_regions');
        if (availableRegionsFilter) {
            const regionMatch = window.location.search.match(/filter\.p\.m\.custom\.available_regions=([^&]+)/);
            if (regionMatch && regionMatch[1]) {
                const regionValue = decodeURIComponent(regionMatch[1]);
                linkToFetch.searchParams.set('filter.p.m.custom.available_regions', regionValue);
            }
        } else {
            linkToFetch.searchParams.delete('filter.p.m.custom.available_regions');
        }
        this.loading(true);
        fetch(linkToFetch, {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'text/html',
            },
        })
        .then((response) => response.text())
        .then((responseText) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(responseText, 'text/html');
            const newProducts = doc.querySelector('main product-list');
            const currentProducts = document.querySelector('main product-list');
            const newAsideFilter = doc.querySelector('.filter-aside');
            const currentAsideFilter = document.querySelector('.filter-aside');

            const newSelectedFilters = doc.querySelector('#ProductGridContainer > facet-filters-form-intermediate .active-facets.active-facets-desktop');
            const currentSelectedFilters = document.querySelector('#ProductGridContainer > facet-filters-form-intermediate .active-facets.active-facets-desktop');
            if (newSelectedFilters && currentSelectedFilters) {
                currentSelectedFilters.innerHTML = newSelectedFilters.innerHTML;
            }
            if (newProducts && currentProducts) {
                currentProducts.innerHTML = newProducts.innerHTML;

                // Update the browser URL without reloading the page
                window.history.pushState({}, '', linkToFetch.href);
            }
            if (newAsideFilter && currentAsideFilter) {
                currentAsideFilter.innerHTML = newAsideFilter.innerHTML;
            }
            const pdpBottomFacetSortBy = document.querySelector('.pdp-bottom-facet__sort-by');
            if (pdpBottomFacetSortBy) {
                const newPdpBottomFacetSortBy = doc.querySelector('.pdp-bottom-facet__sort-by');
                if (newPdpBottomFacetSortBy) {
                    pdpBottomFacetSortBy.outerHTML = newPdpBottomFacetSortBy.outerHTML;
                }
            }
            const pdpTopFacetSortBy = document.querySelector('.facets.facets-vertical-sort');
            if (pdpTopFacetSortBy) {
                const newPdpTopFacetSortBy = doc.querySelector('.facets.facets-vertical-sort');
                if (newPdpTopFacetSortBy) {
                    pdpTopFacetSortBy.outerHTML = newPdpTopFacetSortBy.outerHTML;
                }
            }

            const plpBottomFacetAll = document.querySelector('.plp-bottom-facet__all');
            if (plpBottomFacetAll) {
                const newPlpBottomFacetAll = doc.querySelector('.plp-bottom-facet__all');
                if (newPlpBottomFacetAll) {
                    plpBottomFacetAll.innerHTML = newPlpBottomFacetAll.innerHTML;
                }
            }
        })
        .catch((error) => {
            console.error('Error fetching filtered products:', error);
        }).finally(() => {
            this.loading(false);
        });
    }

    loading(isLoading) {
        const loadingClass = 'collection-custom-filter-loading';
        let loadingDom = document.querySelector(`.${loadingClass}`);
        const bodyDom = document.querySelector('body');

        if (isLoading) {
            if (!loadingDom) {
                loadingDom = document.createElement('div');
                loadingDom.className = loadingClass;
                loadingDom.innerHTML = '<div class="spinner loading__spinner"><svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66" width="16" height="16"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"/></svg></div>';
                bodyDom.appendChild(loadingDom);
            }
            
            loadingDom.classList.add('active');
        } else if (!isLoading && loadingDom) {
            loadingDom.classList.remove('active');
        }
        
    }

}

customElements.define('collection-custom-filter', CollectionCustomFilter);